function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-3z {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "ic_journee_alerte",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill_1",
  "data-name": "Fill 1",
  className: "cls-3z",
  d: "M28.9.02C28.1-.629,12.976,14.557,1.879,28.625c0,0-2.818,3.473-1.552,4.767,1.094,1.122,13.915,5,14.431,6.946C15.037,41.386,2.224,69.12,3.027,69S28.673,42.515,31.894,36.631c0,0,.918-1.178-2.646-2.709s-12.534-5.415-12.534-5.415S29.646.617,28.9.02",
  transform: "translate(0 -0.001)"
}));

var SvgIcJourneeAlerte = function SvgIcJourneeAlerte(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_journee_alerte",
    width: 32,
    height: 69,
    viewBox: "0 0 32 69",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcJourneeAlerte, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_journee_alerte.4b012dd0.svg";
export { ForwardRef as ReactComponent };